import nowPaymentsIcon from 'assets/images/nowpayments.svg';

export const paymentWaysIdChannelMap = {
    1: 'worldpay',
    2: 'finmo',
    3: 'bitwallet',
    4: 'awepay',
    5: 'fasapay',
    6: 'eft',
    7: 'web3',
    8: 'usdt',
    9: 'customerSupport',
    10: 'dragonpay',
    11: 'nacepay',
    12: 'paygo'
};

export const paymentWaysNameChannelMap = {
    Worldpay: 'worldpay',
    Finmo: 'finmo',
    Bitwallet: 'bitwallet',
    Awepay: 'awepay',
    Fasapay: 'fasapay',
    'Web3.0': 'web3',
    USDT: 'usdt',
    'Customer Support': 'customerSupport',
    Dragonpay: 'dragonpay',
    'NACE Pay': 'nacepay',
    'Korean Solution': 'koreanSolution',
    'Sub Account': 'ccSubAccount',
    'ExLink': 'exLink',
    PayGo: 'paygo',
    Acxpress: 'Acxpress',
    "Finmo Online": "finmoOnline",
    "Skrill": "skrill",
    "fireblocks": "fireblocks",
    'Bank Transfer': 'eft',
    'Local Bank Transfer': "localEft",
    "SWIFT Bank Transfer(Shares)": "eftShares",
    "Local Bank Transfer(Shares)": "localEftShares",
    "Coin Flux": "cryptoCurrencies",
    'NOWPayments': 'nowPayments'
};

export const paymentIcons = {
    worldpay: require('assets/images/worldPay.jpg'),
    worldpay3ds: require('assets/images/worldPay.jpg'),
    worldpayPng: require('assets/images/Worldpay.png'),
    eft: require('assets/images/BankTransfer.png'),
    localEft: require('assets/images/BankTransfer.png'),
    eftShares: require('assets/images/BankTransfer.png'),
    localEftShares: require('assets/images/BankTransfer.png'),
    usdt: require('assets/images/USDT.png'),
    rapyd: require('assets/images/rapyd.jpg'),
    customerSupport: require('assets/images/CustomerSupport.png'),
    bitwallet: require('assets/images/bitwallet.jpg'),
    awepay: require('assets/images/awepay.jpg'),
    fasapay: require('assets/images/fasapay.jpg'),
    web3: require('assets/images/USDT.png'),
    finmo: require('assets/images/paynowTrans.png'),
    dragonpay: require('assets/images/dragonpay.png'),
    nacepay: require('assets/images/nace.jpeg'),
    nacepayWidget: require('assets/images/nace.jpeg'),
    ccSubAccount: require('assets/images/BankTransfer.png'),
    koreanSolution: require('assets/images/Dynamic Virtual Account 2.png'),
    exLink: require('assets/images/exLink.png'),
    paygo: require('assets/images/paygo.png'),
    acxpress: require('assets/images/acxpress.jpg'),
    Acxpress: require('assets/images/acxpress.jpg'),
    finmoOnline: require('assets/images/finmo.jpg'),
    skrill: require('assets/images/skrill.jpg'),
    cryptoCurrencies: require('assets/images/USDT.png'),
    nowPayments: nowPaymentsIcon,
};

// from currency limit
export const paymentGatewayLimitCurrency = {
    bitwallet: ['USD', 'JPY'],
    awepay: ['IDR', 'MYR', 'THB', 'VND'],
    fasapay: ['IDR'],
    finmo: ['SGD'],
    dragonpay: ['PHP'],
    koreanSolution: ['KRW'],
    worldpay: ['USD', 'AUD', 'GBP', 'EUR', 'CAD', 'SGD'],
    worldpay3ds: ['USD', 'AUD', 'GBP', 'EUR', 'CAD', 'SGD', 'NZD'],
    exLink: ['CNY'],
    nacepayWidget: ['USD'],
    cryptoCurrencies: ['USD'],
    nowPayments: ['USD'],
    paygo: ['KRW'],
    Acxpress: ['KRW'],
    // finmoOnline: ['IDR', 'MYR', 'THB', 'VND', 'PHP'],
    finmoOnline: ['THB', 'PHP'],
};

export const paymentGatewayLimitAmount = {
    dragonpay: {
        PHP: 500,
    },
    koreanSolution: {
        KRW: 130000,
    },
    exLink: {
        CNY: 3000,
    },
    paygo: {
        KRW: 100000
    },
    Acxpress: {
        KRW: 150000
    }
};
export const paymentGatewayMaxLimitAmount = {
    worldpay: {
        AUD: 30000,
        CAD: 20000,
        EUR: 15000,
        GBP: 10000,
        SGD: 20000,
        USD: 15000,
    },
    worldpay3ds: {
        AUD: 30000,
        CAD: 20000,
        EUR: 15000,
        GBP: 10000,
        SGD: 20000,
        USD: 15000,
    },
    nacepayWidget:{
        "USD":50000
    }
};

// to currency limit
export const paymentGatewayLimitToCurrency = {
    // usdt: ['USD'],
    web3: ['USD'],
    nacepay: ['USD', 'CAD', 'EUR', 'AUD', 'GBP'],
    exLink: ['USD', 'AUD', 'EUR'],
};

// to stock limit
export const paymentGatewayLimitToStock = {
    worldpay: ['stock'],
    worldpay3ds: ['stock'],
};


export const nacepayCryptos = [
    'BTC',
    'BCH',
    'ETH',
    'LTC',
    'DOGE',
    'XRP',
    'ERC20USDC',
    'SOL',
    'BNB',
    'DASH',
    'ADA',
    'AVAX',
    'Polygon',
    'ERC20SHIB',
    "ERC20USDT",
    "TRC20USDT"
];

export const processPaymentGateway = (rawData) => {
    return {
        rawData,
    };
};

export const cryptoIcons = {
    USDT: require('assets/images/USDT.png'),
};

export const underMaintenance = [];
export const comingSoon = [];
export const gatewayDisabled = [
    'fireblocks',
    'bitwallet',
    'customerSupport',
    'web3',
    'nacepay',
    'usdt',
    'awepay',
    'worldpay' /*'dragonpay', 'koreanSolution' */,
];

export const paymentGatewayNotAllowedRegion = {
    worldpay: ['US','PH','SG'],
    worldpay3ds: ['US'],
};

export const ccSubAccountAllowedCurrencies = ['USD', 'EUR', 'GBP', 'AUD', 'CAD'];
